<div class="header" [ngStyle]="{ backgroundColor: color }">
  <div class="center">
    <ion-icon [style.color]="color" name="lock-closed"></ion-icon>
  </div>
</div>

<div class="content">
  <div class="popup-message">
    <h3>
      {{ 'MY_ACCOUNT.CONFIRM_PASSWORD.TITLE' | translate }}
    </h3>
  </div>

  <form [formGroup]="passwordForm">
    <ion-row>
      <ion-col>
        <ion-item>
          <ion-input
            [type]="viewPasswordType"
            name="password"
            formControlName="password"
            ngDefaultControl
            placeholder="{{
              'MY_ACCOUNT.CONFIRM_PASSWORD.PLACE_HOLDER' | translate
            }}"
          ></ion-input>
          <ion-icon
            id="viewPasswordIcon"
            (click)="viewPassword()"
            [style.color]="color"
            [name]="viewPasswordIcon"
          ></ion-icon>
        </ion-item>
      </ion-col>
    </ion-row>
  </form>

  <ion-text color="danger" [hidden]="!(confirmPasswordFailed$ | async)">
    {{ 'MY_ACCOUNT.CONFIRM_PASSWORD.ERROR' | translate }}
  </ion-text>

  <div class="popup-message">
    <p>
      {{ 'MY_ACCOUNT.CONFIRM_PASSWORD.FIRST_SUBTITLE' | translate }}
    </p>
    <p>
      {{ 'MY_ACCOUNT.CONFIRM_PASSWORD.SECOND_SUBTITLE' | translate }}
    </p>
  </div>
</div>

<div class="popup-footer">
  <ion-button
    expand="full"
    size="large"
    strong="true"
    fill="clear"
    color="dark"
    (click)="validated.emit('cancel')"
  >
    {{ 'CANCEL' | translate }}
  </ion-button>

  <ion-button
    expand="full"
    size="large"
    strong="true"
    fill="clear"
    [color]="color"
    (click)="validated.emit(passwordForm.value.password)"
  >
    {{ 'OK' | translate }}
  </ion-button>
</div>
